// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_DeclineRefundInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/decline_refund/{id}
 *
 * Validates input for declining a refund request.
 */
import { registerContract } from './validate'

export interface Payroll_DeclineRefundInput {
reason?: string
}

registerContract('Payroll_DeclineRefundInput', {
  reason: { type: 'string',  required: false },
})
